/**
 * Section 3: Access Issues (conditional - shown if no access)
 */

import { useCallback } from 'preact/hooks';
import { useForm } from '@ox/visits-ui/context/FormContext';
import { FileUpload } from '@ox/visits-ui/components/shared/FileUpload';
import { Textarea } from '@ox/visits-ui/components/shared/FormComponents';

export function Section3AccessIssues() {
  const { formData, updateField } = useForm();

  const handleAccessDetailsChange = useCallback(
    (value: string) => updateField('access_issue_details', value),
    [updateField],
  );

  return (
    <div className="form-section">
      <h2>Access Issue Description</h2>

      <Textarea
        label="Can you provide additional details regarding your specific access issue?"
        name="access_issue_details"
        value={formData.access_issue_details || ''}
        onChange={handleAccessDetailsChange}
        autoSize
        required
      />

      <FileUpload
        label="Are there any photos you'd like to provide?"
        mediaType="access_photo"
        sectionNumber={3}
        maxFiles={5}
        accept="image/*"
      />
    </div>
  );
}
